export const GET_USERS_REQUEST = "DENTISTS/GET_USERS_REQUEST";
export const GET_USERS_SUCCESS = "DENTISTS/GET_USERS_SUCCESS";
export const GET_USERS_FAILURE = "DENTISTS/GET_USERS_FAILURE";

export const DELETE_USER_REQUEST = "DENTISTS/DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DENTISTS/DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DENTISTS/DELETE_USER_FAILURE";

export const CHANGE_USER_STATUS_REQUEST = "DENTISTS/CHANGE_USER_STATUS_REQUEST";
export const CHANGE_USER_STATUS_SUCCESS = "DENTISTS/CHANGE_USER_STATUS_SUCCESS";
export const CHANGE_USER_STATUS_FAILURE = "DENTISTS/CHANGE_USER_STATUS_FAILURE";

export const ADD_USER_REQUEST = "DENTISTS/ADD_USER_REQUEST";
export const ADD_USER_SUCCESS = "DENTISTS/ADD_USER_SUCCESS";
export const ADD_USER_FAILURE = "DENTISTS/ADD_USER_FAILURE";

export const EDIT_USER_REQUEST = "DENTISTS/EDIT_USER_REQUEST";
export const EDIT_USER_SUCCESS = "DENTISTS/EDIT_USER_SUCCESS";
export const EDIT_USER_FAILURE = "DENTISTS/EDIT_USER_FAILURE";

export const GET_ALL_USERS_REQUEST = "DENTISTS/GET_ALL_USERS_REQUEST";
export const GET_ALL_USERS_SUCCESS = "DENTISTS/GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_FAILURE = "DENTISTS/GET_ALL_USERS_FAILURE";

export const GET_DENTIST_INFO_REQUEST = "DENTISTS/GET_DENTIST_INFO_REQUEST";
export const GET_DENTIST_INFO_SUCCESS = "DENTISTS/GET_DENTIST_INFO_SUCCESS";
export const GET_DENTIST_INFO_FAILURE = "DENTISTS/GET_DENTIST_INFO_FAILURE";

export const GENERATE_RESET_PASSWORD_LINK_REQUEST = 'DENTISTS/GENERATE_RESET_PASSWORD_LINK_REQUEST';
export const GENERATE_RESET_PASSWORD_LINK_SUCCESS = 'DENTISTS/GENERATE_RESET_PASSWORD_LINK_SUCCESS';
export const GENERATE_RESET_PASSWORD_LINK_FAILURE = 'DENTISTS/GENERATE_RESET_PASSWORD_LINK_FAILURE';


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/Dentists/constants.js